import * as React from 'react';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getUiForgotPassword, submitForgotPassword } from '@/redux/modules/forgotPassword';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import ForgotPassword from '@/components/ForgotPassword/ForgotPassword';
import ForgotPasswordConfirm from '@/components/ForgotPassword/ForgotPasswordConfirm';
import PageTitle from '@/components/PageTitle/PageTitle';
import styled from 'styled-components';

const SendPasswordResetEmailForm = () => {
    const [workflowStep, setWorkflowStep] = React.useState<'submit' | 'confirm'>('submit');

    const forgotPasswordUIState = useAppSelector((state) => getUiForgotPassword(state));

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (forgotPasswordUIState.success) {
            setWorkflowStep('confirm');
        }
    }, [dispatch, forgotPasswordUIState.success]);

    const setEmail = (email: string, sendSMS: boolean) => {
        dispatch(submitForgotPassword(email, sendSMS));
    };

    const resendEmail = () => {
        setWorkflowStep('submit');
    };

    return (
        <Container>
            <FormContainer>
                {workflowStep === 'submit' ? (
                    <>
                        <CenteredPageTitle
                            key={1}
                            title={<FormattedMessage id="please_enter_email_below" />}
                        />
                        <SubHeaderContainer key={0}>
                            <FormattedMessage id="send_reset_password" />
                        </SubHeaderContainer>
                        <ForgotPassword submitForgotPassword={setEmail} />
                    </>
                ) : (
                    <>
                        <CenteredPageTitle title={<FormattedMessage id="check_your_email" />} />
                        <ForgotPasswordConfirm resendEmail={resendEmail} />
                    </>
                )}
            </FormContainer>
        </Container>
    );
};

export default SendPasswordResetEmailForm;

const Container = styled.div`
    display: flex;
    justify-content: center;
`;

const FormContainer = styled.div`
    transition: left 0.3s ease-out;
    width: 537px;
    min-height: 400px;
    padding: 15px 20px;
    top: 215px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidthNum + 1}px) {
        padding: 0 73px;
    }
`;

const CenteredPageTitle = styled(PageTitle)`
    width: 100%;
    text-align: center;
`;

const SubHeaderContainer = styled.span`
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    margin-bottom: 24px;
`;
